import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Profile } from 'src/app/interfaces/user';
import { RouterService } from 'src/app/services/router/router.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';

export interface PageTitleInput {
  name?: string;
  title?: string;
  descriptions?: string[];
  subTitle?: string;
  currentStep?: number;
  totalStep?: number;
  url?: string;
  profile?: Profile | null;
}

@Component({
  selector: 'common-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit {

  @Input() data: PageTitleInput | undefined;
  @Input() isHost = true;
  @Input() isLoginNeeded = true;
  @Input() textAlign?: 'center';

  constructor(
    public userService: UserService,
    private elementRef: ElementRef,
    private routerService: RouterService
  ) {
  }

  get disabled(): boolean {
    if (this.isHost) {
      if (this.isLoginNeeded && !this.userService.isLoggedIn) {
        return true;
      }
    }
    return false;
  }

  ngOnInit(): void {
  }

  selectLink(): void {
    const inputElem: HTMLInputElement = this.elementRef.nativeElement.querySelector('.url');
    inputElem.setSelectionRange(0, 9999);
    inputElem.focus();
  }

  navigateToProfile(): void {
    if (this.data?.profile) {
      this.routerService.navigate(`${environment.webUrl}/${this.data.profile.uniqueName}`);
    }
  }
}
